import * as React from 'react';
import { Component } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import { enableAutosave } from '../../redux/actions/general/autosave';
import styles from '../../styles/forms/my_company_members/UserEmploymentTermsForm.scss';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual/dist/react-contextual.es';
import Localization from '../../helpers/Localization';
import { __, mapStateToProps, redirect } from '../../core/utils';
import * as _ from 'lodash';
import classNames from 'classnames';
import Input from '../../components/Input';
import Select from '../../components/Select';
import DateTimePicker from '../../components/DateTimePicker';

@reduxForm({
  form: 'my_company_members.user_employment_terms',
  enableReinitialize: true,
})
@withRouter
@mapStateToProps((state) => ({
  table: state.table['my_company_members'],
  user_id: state.auth.id,
}))
@subscribe(Localization, 'localization')
class UserEmploymentTermsForm extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  UNSAFE_componentWillReceiveProps() {
    enableAutosave(this.props.form);
  }

  render() {
    const { data, user_id } = this.props;
    // const { project_languages, status } = data;

    const disabled = false;

    // const workplaces = [
    //   { label: __('home'), value: 'home' },
    //   { label: __('office'), value: 'office' },
    // ];

    const type_of_employments = [
      { label: __('employee'), value: 'employee' },
      { label: __('external'), value: 'external' },
    ];

    // const timesheets = [
    //   { label: __('yes'), value: 'yes' },
    //   { label: __('no'), value: 'no' },
    // ];

    return (
      <Form onSubmit={this.props.handleSubmit}>
        <div className={styles.form}>
          <div className={styles.flex}>
            <div className={styles.f2}>
              <Field
                name='valid_from'
                component={DateTimePicker}
                label={__('table.columns.valid_from')}
                footer
              />
            </div>
            <div className={styles.f2}>
              <Field
                name='valid_to'
                component={DateTimePicker}
                label={__('table.columns.valid_to')}
                footer
              />
            </div>
          </div>
          <div className={styles.flex}>
            {/* <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='workplace'
                component={Select}
                label={__('table.columns.workplace')}
                options={workplaces}
              />
            </div> */}
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='type'
                component={Select}
                label={__('table.columns.type_of_employment')}
                options={type_of_employments}
              />
            </div>
            <div className={styles.f1}>
              {/* <Field
                disabled={disabled}
                name='timesheet'
                component={Select}
                label={__('table.columns.timesheet')}
                options={timesheets}
              /> */}
            </div>
          </div>

          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='monday_minutes'
                component={Input}
                label={__('table.columns.monday_minutes')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='tuesday_minutes'
                component={Input}
                label={__('table.columns.tuesday_minutes')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='wednesday_minutes'
                component={Input}
                label={__('table.columns.wednesday_minutes')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='thursday_minutes'
                component={Input}
                label={__('table.columns.thursday_minutes')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='friday_minutes'
                component={Input}
                label={__('table.columns.friday_minutes')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='saturday_minutes'
                component={Input}
                label={__('table.columns.saturday_minutes')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='sunday_minutes'
                component={Input}
                label={__('table.columns.sunday_minutes')}
              />
            </div>
          </div>

          {/* <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='total_working_hours'
                component={Input}
                label={__('table.columns.total_working_hours')}
              />
            </div>

            <div className={styles.f3} />
          </div> */}

          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='vacation_days_base'
                component={Input}
                label={__('table.columns.vacation_days_base')}
              />
            </div>

            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='minutes_off_base'
                component={Input}
                label={__('table.columns.minutes_off_base')}
              />
            </div>

            <div className={styles.f1} />
          </div>

          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='last_year_vacation_days'
                component={Input}
                label={__('table.columns.last_year_vacation_days')}
              />
            </div>

            <div className={styles.f1}>
              {/* <Field
                disabled={disabled}
                name='overtime_substitution'
                component={Input}
                label={__('table.columns.overtime_substitution')}
              /> */}
            </div>

            <div className={styles.f1} />
          </div>

          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='used_vacation_days'
                component={Input}
                label={__('table.columns.used_vacation_days')}
              />
            </div>

            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='used_minutes_off'
                component={Input}
                label={__('table.columns.used_minutes_off')}
              />
            </div>

            <div className={styles.f1} />
          </div>

          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='vacation_days_remaining'
                component={Input}
                label={__('table.columns.vacation_days_remaining')}
              />
            </div>

            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='minutes_off_remaining'
                component={Input}
                label={__('table.columns.minutes_off_remaining')}
              />
            </div>

            <div className={styles.f1} />
          </div>

          {/* <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='working_days'
                component={Input}
                label={__('table.columns.working_days')}
              />
            </div>

            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='sick_leaves'
                component={Input}
                label={__('table.columns.sick_leaves')}
              />
            </div>

            <div className={styles.f1} />
          </div> */}
          {/* <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='working_hours'
                component={Input}
                label={__('table.columns.working_hours')}
              />
            </div>

            <div className={styles.f3} />
          </div> */}

          {/* <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='overtime_hours'
                component={Input}
                label={__('table.columns.overtime_hours')}
              />
            </div>

            <div className={styles.f3} />
          </div> */}

          <div className={classNames(styles.flex, styles.links)}>
            <div>
              <span>{__('my_timesheet')}</span>
              <span onClick={() => redirect('/timesheets')}>{__('link')}</span>
            </div>
          </div>
        </div>
      </Form>
    );
  }
}

export default UserEmploymentTermsForm;
